import Logo from "./Logo";
import { PHONE_NUMBER, PHONE_TEL } from "./navigation";

const SNS_LINKS = [
  { label: "인스타그램", href: "https://www.instagram.com", icon: "ri-instagram-line" },
  { label: "유튜브", href: "https://www.youtube.com", icon: "ri-youtube-line" },
  { label: "네이버 블로그", href: "https://blog.naver.com", icon: "naver" },
  { label: "카카오톡", href: "https://www.kakaocorp.com", icon: "ri-chat-3-line" },
];

export default function Footer() {
  return (
    <footer className="bg-primary-50 border-t border-primary-100">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-10">
          {/* 브랜드 */}
          <div className="flex flex-col items-start gap-4">
            <Logo />
            <p className="text-sm text-foreground-600 leading-relaxed">
              피부 고민, 비앙카와 함께
              <br />
              건강하고 빛나는 피부를 완성해보세요.
            </p>
          </div>

          {/* 연락처 */}
          <div className="flex flex-col gap-3">
            <h4 className="text-sm font-semibold text-foreground-900">상담 안내</h4>
            <a href={PHONE_TEL} className="flex items-center gap-2 text-sm text-foreground-600 hover:text-primary-600 cursor-pointer">
              <i className="ri-phone-line text-primary-500"></i>
              <span>{PHONE_NUMBER}</span>
            </a>
            <div className="flex items-center gap-2 text-sm text-foreground-600">
              <i className="ri-time-line text-primary-500"></i>
              <span>평일 10:00 - 20:00 · 토 10:00 - 17:00</span>
            </div>
            <div className="flex items-center gap-2 text-sm text-foreground-600">
              <i className="ri-map-pin-line text-primary-500"></i>
              <span>서울특별시 강남구</span>
            </div>
          </div>

          {/* SNS */}
          <div className="flex flex-col gap-3">
            <h4 className="text-sm font-semibold text-foreground-900">비앙카 소식</h4>
            <div className="flex items-center gap-3">
              {SNS_LINKS.map((sns) => (
                <a
                  key={sns.label}
                  href={sns.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={sns.label}
                  title={sns.label}
                  className="w-11 h-11 rounded-full bg-white border border-primary-100 flex items-center justify-center text-primary-600 hover:bg-primary-500 hover:text-white hover:border-primary-500 transition-all cursor-pointer"
                >
                  {sns.icon === "naver" ? (
                    <span className="text-base font-bold leading-none">N</span>
                  ) : (
                    <i className={`${sns.icon} text-xl`}></i>
                  )}
                </a>
              ))}
            </div>
            <p className="text-xs text-foreground-500 mt-1">
              새로운 프로그램과 뷰티 소식을 만나보세요
            </p>
          </div>
        </div>

        <div className="max-w-6xl mx-auto mt-10 pt-6 border-t border-primary-100 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">© 2026 비앙카 피부관리. All rights reserved.</p>
          <p className="text-xs text-foreground-400">BIANCA SKIN CARE</p>
        </div>
      </div>
    </footer>
  );
}